export const config = {
    api : 'https://url-shortener-backend-489g.onrender.com'
    // api:"http://localhost:3007"
}